<!----
    Author: hjlee
    Description:
        사용자 프로필 이미지 컨트롤
---->
<template>
  <div class="profile-img-area">
    <centered-image
      v-if="innerUser && innerUser.thumb"
      :class="{'img-profile': true, 'clickable': showOriginal && innerUser && innerUser.thumb}"
      :src="getImgUrl(innerUser.thumb)"
      :alt="innerUser.nm + '(' + innerUser.userId + ')'"
      :cover="true"
      @click="showImageViewer()"
    />
    <centered-image v-else-if="innerUser" class="img-profile" src="/img/thumb/defaultUser.png" :alt="innerUser.nm + '(' + innerUser.userId + ')'" :cover="true" />

    <image-viewer v-if="innerUser && innerUser.thumb" ref="imageViewerRef" :src="getImgUrl(innerUser.thumb, 1600)" :alt="innerUser.nm + '(' + innerUser.userId + ')'" />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      required: true
    },
    user: {
      type: Object,
      default: undefined
    },
    showOriginal: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      innerUser: undefined,
      isShowOriginal: false
    }
  },
  watch: {
    isShowOriginal(newVal, oldVal) {
      if (newVal) {
        $(this.$el)
          .find('.original-image-area')
          .fadeIn()
      } else {
        $(this.$el)
          .find('.original-image-area')
          .fadeOut()
      }
    },
    loggedInUser(newVal, oldVal) {
      this.innerUser = newVal
    }
  },
  mounted() {
    if (this.user) {
      this.innerUser = this.user
    } else {
      this.innerUser = this.loggedInUser
    }
    $(this.$el).width(this.size)
    $(this.$el).height(this.size)
    $(this.$el).css('border-radius', this.size / 2 + 'px')
  },
  methods: {
    showImageViewer: function() {
      if (this.showOriginal) {
        this.$refs.imageViewerRef.showImageViewer()
      }
    }
  }
}
</script>

<style scoped>
.profile-img-area {
  border: 1px solid #aaaaaa;
  overflow: hidden;
  margin: auto;
}
.original-image-area {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: none;
  z-index: 2000;
}
</style>
